(function () {
    const about = document.querySelector('.hxg1-about');
    if (!about) return;

    const content = about.querySelector('.hxg1-about-content');
    if (!content) return;

    const sectionHeadings = Array.from(content.children).filter(function (element) {
        return element.tagName === 'H1';
    });

    if (sectionHeadings.length !== 2) return;

    const tabList = document.createElement('div');
    tabList.className = 'hxg1-about-tabs';
    tabList.setAttribute('role', 'tablist');
    tabList.setAttribute('aria-label', 'About HXG1');

    const tabs = [];
    const panels = [];

    sectionHeadings.forEach(function (heading, index) {
        const label = heading.textContent.trim();
        const slug = index === 0 ? 'leadership' : 'about-hxg1';
        const nextHeading = sectionHeadings[index + 1] || null;
        const panel = document.createElement('section');
        const tab = document.createElement('button');

        panel.className = 'hxg1-about-panel';
        panel.id = 'hxg1-about-panel-' + slug;
        panel.setAttribute('role', 'tabpanel');
        panel.setAttribute('aria-labelledby', 'hxg1-about-tab-' + slug);

        tab.className = 'hxg1-about-tab';
        tab.id = 'hxg1-about-tab-' + slug;
        tab.type = 'button';
        tab.textContent = label;
        tab.setAttribute('role', 'tab');
        tab.setAttribute('aria-controls', panel.id);

        let node = heading.nextSibling;
        while (node && node !== nextHeading) {
            const nextNode = node.nextSibling;
            panel.appendChild(node);
            node = nextNode;
        }

        heading.remove();
        tabList.appendChild(tab);
        tabs.push(tab);
        panels.push(panel);
    });

    function buildFounderCards(panel) {
        const founderHeadings = Array.from(panel.children).filter(function (element) {
            return element.tagName === 'H3';
        });

        if (founderHeadings.length !== 2) return;

        const grid = document.createElement('div');
        grid.className = 'hxg1-founder-grid';
        panel.insertBefore(grid, founderHeadings[0]);

        founderHeadings.forEach(function (heading, index) {
            const name = heading.textContent.trim();
            const nextHeading = founderHeadings[index + 1] || null;
            const card = document.createElement('article');
            const portrait = document.createElement('div');
            const image = document.createElement('img');

            card.className = 'hxg1-founder-card';
            portrait.className = 'hxg1-founder-portrait';
            image.className = 'hxg1-founder-image';
            image.src = index === 0 ? about.dataset.joeHeadshot : about.dataset.michaelHeadshot;
            image.alt = name;
            image.width = 480;
            image.height = 480;
            image.loading = 'lazy';
            image.decoding = 'async';
            portrait.appendChild(image);
            card.appendChild(portrait);

            let node = heading;
            while (node && node !== nextHeading) {
                const nextNode = node.nextSibling;
                card.appendChild(node);
                node = nextNode;
            }

            heading.classList.add('hxg1-founder-name');

            const title = heading.nextElementSibling;
            if (title) title.classList.add('hxg1-founder-title');

            const linkedIn = card.querySelector('a[href*="linkedin.com"]');
            if (linkedIn) {
                linkedIn.classList.add('hxg1-founder-link');
                linkedIn.target = '_blank';
                linkedIn.rel = 'noopener noreferrer';
                const linkRow = linkedIn.closest('p');
                if (linkRow) linkRow.classList.add('hxg1-founder-link-row');
            }

            grid.appendChild(card);
        });
    }

    buildFounderCards(panels[0]);
    content.prepend(tabList);
    panels.forEach(function (panel) {
        content.appendChild(panel);
    });

    function selectTab(selectedIndex, moveFocus) {
        tabs.forEach(function (tab, index) {
            const selected = index === selectedIndex;
            tab.setAttribute('aria-selected', String(selected));
            tab.tabIndex = selected ? 0 : -1;
            panels[index].hidden = !selected;
        });

        if (moveFocus) tabs[selectedIndex].focus();
    }

    tabs.forEach(function (tab, index) {
        tab.addEventListener('click', function () {
            selectTab(index, false);
        });

        tab.addEventListener('keydown', function (event) {
            let nextIndex;

            if (event.key === 'ArrowRight') nextIndex = (index + 1) % tabs.length;
            if (event.key === 'ArrowLeft') nextIndex = (index - 1 + tabs.length) % tabs.length;
            if (event.key === 'Home') nextIndex = 0;
            if (event.key === 'End') nextIndex = tabs.length - 1;
            if (nextIndex === undefined) return;

            event.preventDefault();
            selectTab(nextIndex, true);
        });
    });

    selectTab(0, false);
    about.classList.add('is-enhanced');
})();
